module.exports = __webpack_public_path__ + "img/dsci0145.3fe9fbe7.jpg";